<template lang="pug">
	.project-actions-rename(v-if="showed && Project.SelectedProject")
		.card
			.card-header
				i.fa.fa-edit
				span Rename Project
			.card-body.collapse.show
				.form-horizontal
					.form-group
						label.col-form-label(for="prependedInput") New title of project
							.controls
								input.form-control(id="prependedInput" size="16" type="text" v-model="title")
					.form-actions
						button.btn.btn-primary(type="submit" v-on:click="rename()") Rename project
						button.btn.btn-ghost-dark(type="button" v-on:click="hide()") Cancel
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Template } 		from './../../services/Template';
	import { Project } 			from './../../services/Project';

	import { Notifications }	from './../../services/Notifications';

	export default {
		name: "ProjectActionsRename",
		mixins: [Screen],
		screen: {
			updateOn: []
		},
		data() {

			this.Template = Template;
			this.Project = Project;

			return {
				title: ''
			}
		},
		methods: {
			collectData() {

				if (!Project.SelectedProject) return;

				this.title = Project.SelectedProject.title;

			},
			rename() {

				const new_name = this.title.trim();

				if (!new_name) return Notifications.showError(`Invalid project name!`);

				Project.SelectedProject.title = this.title;

				Broadcast.call("Project Renamed");

				Server.sendToSocket({
					RenameProject: {
						projectId: Project.SelectedProject.id,
						title: this.title
					}
				});

				this.hide();

			}
		}
	}
</script>


<style lang="sass">

	.project-actions-rename
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 220px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			input
				width: 460px
				margin-top: 5px

			.btn-ghost-dark
				float: right
				color: #fff

</style>

